import React, { Component } from 'react';

import { routes } from "../config/routes";

import 'react-bootstrap';
import { Redirect, Route, Switch } from "react-router-dom";
import store from '../store/configureStore';
import { initializeKeyAction, setBusinessAction, setSearchKeyAction } from '../actions/topBannerAction';
import { setGlobalSearchKeyAction } from '../actions/searchAction';
import { setBlogBusinessAction } from '../actions/blogAction';
/****************************************
    Component for routing to replace content
    @author  IMH003
    @date    2019.5.27
    @version 0.1    
 ******************************************/

class Root extends Component {

    constructor(props) {
        super(props);
        this.state = {

        }

    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    componentWillReceiveProps(newProps) {
        store.dispatch(initializeKeyAction());

        const { location } = newProps.history;
        if (location.pathname.indexOf('/search') === -1) {
            store.dispatch(setGlobalSearchKeyAction(''));
        }
        if (location.pathname.indexOf('/portfolio') === -1) {
            store.dispatch(setBusinessAction('all'));
            store.dispatch(setSearchKeyAction(''))
        }
        if (location.pathname.indexOf('/blog') === -1) {
            store.dispatch(setBlogBusinessAction(-1));
        }


    }

    render() {
        return (
            <div className="page-container">
                <div className="main-content">

                    <Switch>
                        <Route exact path={`/`}
                            render={() => <Redirect replace to={`/home`} />} />

                        {
                            routes.map((prop, key) => {
                                if (prop.exact) {
                                    return (<Route exact path={prop.path} component={prop.component} key={key} />)
                                }
                                return (<Route path={prop.path} component={prop.component} key={key} />)
                            })
                        }

                    </Switch>

                </div>
            </div>
        );
    }
}

export default Root;
